import { render, staticRenderFns } from "./ProgressionLabel.vue?vue&type=template&id=473b049a&scoped=true&"
import script from "./ProgressionLabel.vue?vue&type=script&lang=js&"
export * from "./ProgressionLabel.vue?vue&type=script&lang=js&"
import style0 from "./ProgressionLabel.vue?vue&type=style&index=0&id=473b049a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473b049a",
  null
  
)

export default component.exports